import classnames from 'classnames'
import PropTypes from 'prop-types'
import React, { useRef } from 'react'
import uniqid from 'uniqid'

import './ContextMenu.scss'

export const CONTEXT_MENU_VARIANT_LIGHT = 'light'
export const CONTEXT_MENU_VARIANT_DARK = 'dark'
export const CONTEXT_MENU_SIZE_MD = 'md'
export const CONTEXT_MENU_SIZE_SM = 'sm'

export const ContextMenu = ({
  items,
  className,
  itemsClickCallback,
  variant,
  selected,
  size,
  'data-mu-test': dataAttributeTest,
  showArrow,
  direction,
  offsetLeft
}) => {
  const { current: uuid } = useRef(uniqid('e-context-menu-'))

  return (
    <ul
      className={classnames('e-context-menu', className, {
        'e-context-menu--light': variant === CONTEXT_MENU_VARIANT_LIGHT,
        'e-context-menu--dark': variant === CONTEXT_MENU_VARIANT_DARK,
        'e-context-menu--md': size === CONTEXT_MENU_SIZE_MD,
        'e-context-menu--sm': size === CONTEXT_MENU_SIZE_SM,
        'e-context-menu--arrow-up': showArrow && direction === 'down',
        'e-context-menu--arrow-down': showArrow && direction === 'up'
      })}
      data-mu-test={classnames('menu', dataAttributeTest)}
      style={{
        '--offset-left': offsetLeft
      }}
    >
      {items.map((item, i) => {
        const { 'data-mu-test': itemDataAttributeTest } = item
        const handleClick = e => {
          if (typeof item.onClick === 'function') {
            item.onClick(item.value, e)
          }
          if (typeof itemsClickCallback === 'function') {
            itemsClickCallback(e)
          }
        }
        return (
          !item.hide && (
            <li
              key={`${uuid}-item-${i}`}
              className={classnames(item.className, 'e-context-menu__item', {
                'e-context-menu__item--separator': item.separator,
                'e-context-menu__item--selected':
                  item.value && item.value === selected,
                'e-context-menu__item--disabled': !!item.disabled
              })}
              data-mu-test={itemDataAttributeTest}
            >
              <a onClick={handleClick}>{item.label}</a>
            </li>
          )
        )
      })}
    </ul>
  )
}

ContextMenu.defaultProps = {
  variant: CONTEXT_MENU_VARIANT_LIGHT,
  size: CONTEXT_MENU_SIZE_MD,
  showArrow: false,
  offsetLeft: '0px'
}

ContextMenu.propTypes = {
  className: PropTypes.string,
  itemsClickCallback: PropTypes.func,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      separator: PropTypes.bool,
      className: PropTypes.string,
      onClick: PropTypes.func,
      value: PropTypes.any,
      hide: PropTypes.bool,
      disabled: PropTypes.bool
    })
  ),
  selected: PropTypes.string,
  variant: PropTypes.oneOf([
    CONTEXT_MENU_VARIANT_LIGHT,
    CONTEXT_MENU_VARIANT_DARK
  ]),
  size: PropTypes.oneOf([CONTEXT_MENU_SIZE_SM, CONTEXT_MENU_SIZE_MD]),
  /**
   * Additional values for data-attribute used for tests and tracking
   **/
  'data-mu-test': PropTypes.string,
  showArrow: PropTypes.bool,
  direction: PropTypes.oneOf(['up', 'down', undefined]),
  offsetLeft: PropTypes.string
}
